<div id="app">
    <app-header></app-header>
    <div class="contentsec">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>

<!----this.lastUrlSegment = "fellowshiphealthshare";
var url = "https://sandbox.fellowshiphealthshare.org/vasquez-api/api/GetCompanySettings/fellowshiphealthshare"--->